<!--floorSpot 楼宇点位-->
<template>
  <div class="right-table">
    <el-input style="width: 360px;" size="mini" placeholder="输入设备名称、设备ID、回路编号搜索" suffix-icon="el-icon-search"
      v-model="filterText2"> </el-input>
    <div class="num_box">
      <div class="t">
        <div class="num">1020</div>
        <div class="e">设备总数</div>
      </div>
      <div class="line"></div>
      <div class="t">
        <div class="num">864</div>
        <div class="e">设备开启数</div>
      </div>
      <div class="line"></div>
      <div class="t">
        <div class="num">278</div>
        <div class="e">设备关闭数</div>
      </div>
      <div class="line"></div>
      <div class="t">
        <div class="num">26</div>
        <div class="e">设备故障数</div>
      </div>
    </div>
    <div class="top-table">
      <div class="titles">
        <div class="leftd"><span>开启：</span><img src="./img/l1.png"><span>关闭：</span><img
            src="./img/l4.png"><span>故障：</span><img src="./img/l5.png"></div>

        <div class="rightd" @click="goUrl('/floorCard')">
          <span style="font-size: 12px;padding: 2px 4px; background-color: #0D75D4; color: #fff;">图片</span>
          <span style="font-size: 12px;padding: 2px 4px;  ">卡片</span>
        </div>
      </div>
      <div class="center">
        <img src="./img/e.png" style="width: 100%;">
        <span class="spot">
          <el-popover trigger="click" placement="right-start">
            <div class="popo_box">
              <div class="a" :class="{'active2': !value1}" :style="{backgroundColor:value1?'#368ed9':'#e6e6e6'}">
                1#照明回路
              </div>
              <div class="b">
                <div class="n">设备编号：</div>zm167
              </div>
              <div class="b">
                <div class="n">设备位置：</div>A栋A座1楼
              </div>
              <div class="b">
                <div class="n">运行时长：</div>12 h
              </div>
              <div class="e"><el-switch class="sw" v-model="value1" size="mini" active-color="#13ce66"
                  inactive-color="#CCC">
                </el-switch>
                <img class="swImg" v-if="value1" src="./img/lg.png">
                <img class="swImg" v-else src="./img/la.png">
                <div class="swUl" :class="{'active': value1}">
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                </div>
              </div>
            </div>
            <div slot="reference" class="name-wrapper" style="top: 15%;left: 20%;">
              <img v-if="value1" src="./img/l1.png">
              <img v-else src="./img/l3.png">
            </div>
          </el-popover>
          <el-popover trigger="click" placement="right-start">
            <div class="popo_box">
              <div class="a" :class="{'active2': !value1}" :style="{backgroundColor:value1?'#368ed9':'#e6e6e6'}">
                1#照明回路</div>
              <div class="b">
                <div class="n">设备编号：</div>zm167
              </div>
              <div class="b">
                <div class="n">设备位置：</div>A栋A座1楼
              </div>
              <div class="b">
                <div class="n">运行时长：</div>12 h
              </div>
              <div class="e"><el-switch class="sw" v-model="value1" size="mini" active-color="#13ce66"
                  inactive-color="#CCC">
                </el-switch>
                <img class="swImg" v-if="value1" src="./img/lg.png">
                <img class="swImg" v-else src="./img/la.png">
                <div class="swUl" :class="{'active': value1}">
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                </div>
              </div>
            </div>
            <div slot="reference" class="name-wrapper" style="top: 12%;left: 40%;">

              <img v-if="value1" src="./img/l2.png">
              <img v-else src="./img/l3.png">
            </div>
          </el-popover>
          <el-popover trigger="click" placement="right-start">
            <div class="popo_box">
              <div class="a" :class="{'active2': !value1}" :style="{backgroundColor:value1?'#368ed9':'#e6e6e6'}">
                1#照明回路</div>
              <div class="b">
                <div class="n">设备编号：</div>zm167
              </div>
              <div class="b">
                <div class="n">设备位置：</div>A栋A座1楼
              </div>
              <div class="b">
                <div class="n">运行时长：</div>12 h
              </div>
              <div class="e"><el-switch class="sw" v-model="value1" size="mini" active-color="#13ce66"
                  inactive-color="#CCC">
                </el-switch>
                <img class="swImg" v-if="value1" src="./img/lg.png">
                <img class="swImg" v-else src="./img/la.png">
                <div class="swUl" :class="{'active': value1}">
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                </div>
              </div>
            </div>
            <div slot="reference" class="name-wrapper" style="top: 24%;left: 60%;">
              <img src="./img/l2.png">
            </div>
          </el-popover>
          <el-popover trigger="click" placement="right-start">
            <div class="popo_box">
              <div class="a" :class="{'active2': !value1}" :style="{backgroundColor:value1?'#368ed9':'#e6e6e6'}">
                1#照明回路</div>
              <div class="b">
                <div class="n">设备编号：</div>zm167
              </div>
              <div class="b">
                <div class="n">设备位置：</div>A栋A座1楼
              </div>
              <div class="b">
                <div class="n">运行时长：</div>12 h
              </div>
              <div class="e"><el-switch class="sw" v-model="value1" size="mini" active-color="#13ce66"
                  inactive-color="#CCC">
                </el-switch>
                <img class="swImg" v-if="value1" src="./img/lg.png">
                <img class="swImg" v-else src="./img/la.png">
                <div class="swUl" :class="{'active': value1}">
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                </div>
              </div>
            </div>
            <div slot="reference" class="name-wrapper" style="top: 40%;left: 81.5%;">
              <img src="./img/l2.png">
            </div>
          </el-popover>



          <el-popover trigger="hover" placement="top">
            <p>LED电梯厅</p>
            <div slot="reference" class="name-wrapper" style="top: 66%;left: 18%;">
              <img src="./img/l2.png">
            </div>
          </el-popover>
          <el-popover trigger="hover" placement="top">
            <p>办公区</p>
            <div slot="reference" class="name-wrapper" style="top: 81%;left: 41.4%;">
              <img src="./img/l2.png">
            </div>
          </el-popover>
          <el-popover trigger="hover" placement="top">
            <p>接待室</p>
            <div slot="reference" class="name-wrapper" style="top: 73.5%;left: 68.4%;">
              <img src="./img/l2.png">
            </div>
          </el-popover>
          <el-popover trigger="hover" placement="top">
            <p>经理室</p>
            <div slot="reference" class="name-wrapper" style="top: 77.5%;left: 82.4%;">
              <img src="./img/l2.png">
            </div>
          </el-popover>

          <el-popover trigger="click" placement="right-start">
            <div class="popo_box">
              <div class="a" :class="{'active2': !value1}" :style="{backgroundColor:value1?'#ff7a2f':'#e6e6e6'}">
                1#照明回路
              </div>
              <div class="b">
                <div class="n">设备编号：</div>zm167
              </div>
              <div class="b">
                <div class="n">设备位置：</div>A栋A座1楼
              </div>
              <div class="b">
                <div class="n">运行时长：</div>12 h
              </div>
              <div class="e"><el-switch class="sw" v-model="value1" size="mini" active-color="#13ce66"
                  inactive-color="#CCC">
                </el-switch>
                <img class="swImg" v-if="value1" src="./img/lg.png">
                <img class="swImg" v-else src="./img/la.png">
                <div class="swUl" :class="{'active': value1}">
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                </div>
              </div>
            </div>
            <div slot="reference" class="name-wrapper" style="top: 14%;left:32%;">
              <img v-if="value1" src="./img/l6.png">
              <img v-else src="./img/l3.png">
            </div>
          </el-popover>


          <el-popover trigger="click" placement="right-start">
            <div class="popo_box">
              <div class="a" :class="{'active2': !value1}" :style="{backgroundColor:value1?'#ff7a2f':'#e6e6e6'}">
                1#照明回路
              </div>
              <div class="b">
                <div class="n">设备编号：</div>zm167
              </div>
              <div class="b">
                <div class="n">设备位置：</div>A栋A座1楼
              </div>
              <div class="b">
                <div class="n">运行时长：</div>12 h
              </div>
              <div class="e"><el-switch class="sw" v-model="value1" size="mini" active-color="#13ce66"
                  inactive-color="#CCC">
                </el-switch>
                <img class="swImg" v-if="value1" src="./img/lg.png">
                <img class="swImg" v-else src="./img/la.png">
                <div class="swUl" :class="{'active': value1}">
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                </div>
              </div>
            </div>
            <div slot="reference" class="name-wrapper" style="top: 29%;left: 81%;">
              <img v-if="value1" src="./img/l6.png">
              <img v-else src="./img/l3.png">
            </div>
          </el-popover>

          <el-popover trigger="click" placement="right-start">
            <div class="popo_box">
              <div class="a" :class="{'active2': !value1}" :style="{backgroundColor:value1?'#ff7a2f':'#e6e6e6'}">
                1#照明回路
              </div>
              <div class="b">
                <div class="n">设备编号：</div>zm167
              </div>
              <div class="b">
                <div class="n">设备位置：</div>A栋A座1楼
              </div>
              <div class="b">
                <div class="n">运行时长：</div>12 h
              </div>
              <div class="e"><el-switch class="sw" v-model="value1" size="mini" active-color="#13ce66"
                  inactive-color="#CCC">
                </el-switch>
                <img class="swImg" v-if="value1" src="./img/lg.png">
                <img class="swImg" v-else src="./img/la.png">
                <div class="swUl" :class="{'active': value1}">
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                </div>
              </div>
            </div>
            <div slot="reference" class="name-wrapper" style="top: 66.5%;left: 57.3%;">
              <img v-if="value1" src="./img/l6.png">
              <img v-else src="./img/l3.png">
            </div>
          </el-popover>

          <el-popover trigger="click" placement="right-start">
            <div class="popo_box">
              <div class="a" :class="{'active2': !value1}" :style="{backgroundColor:value1?'#ff7a2f':'#e6e6e6'}">
                1#照明回路
              </div>
              <div class="b">
                <div class="n">设备编号：</div>zm167
              </div>
              <div class="b">
                <div class="n">设备位置：</div>A栋A座1楼
              </div>
              <div class="b">
                <div class="n">运行时长：</div>12 h
              </div>
              <div class="e"><el-switch class="sw" v-model="value1" size="mini" active-color="#13ce66"
                  inactive-color="#CCC">
                </el-switch>
                <img class="swImg" v-if="value1" src="./img/lg.png">
                <img class="swImg" v-else src="./img/la.png">
                <div class="swUl" :class="{'active': value1}">
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                </div>
              </div>
            </div>
            <div slot="reference" class="name-wrapper" style="top: 45%;left: 14.4%;">
              <img v-if="value1" src="./img/l6.png">
              <img v-else src="./img/l3.png">
            </div>
          </el-popover>


          <el-popover trigger="click" placement="right-start">
            <div class="popo_box">
              <div class="a  " :class="{'active2': !value2}" :style="{backgroundColor:value2?'#368ed9':'#e6e6e6'}">
                1#照明回路
              </div>
              <div class="b">
                <div class="n">设备编号：</div>zm167
              </div>
              <div class="b">
                <div class="n">设备位置：</div>A栋A座1楼
              </div>
              <div class="b">
                <div class="n">运行时长：</div>12 h
              </div>
              <div class="e"><el-switch class="sw" v-model="value2" size="mini" active-color="#13ce66"
                  inactive-color="#CCC">
                </el-switch>
                <img class="swImg" v-if="value2" src="./img/lg.png">
                <img class="swImg" v-else src="./img/la.png">
                <div class="swUl" :class="{'active': value2}">
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                </div>
              </div>
            </div>
            <div slot="reference" class="name-wrapper" style="top: 7%;left: 51%;">
              <img v-if="value2" src="./img/l1.png">
              <img v-else src="./img/l3.png">
            </div>
          </el-popover>

          <el-popover trigger="click" placement="right-start">
            <div class="popo_box">
              <div class="a  " :class="{'active2': !value2}" :style="{backgroundColor:value2?'#368ed9':'#e6e6e6'}">
                1#照明回路
              </div>
              <div class="b">
                <div class="n">设备编号：</div>zm167
              </div>
              <div class="b">
                <div class="n">设备位置：</div>A栋A座1楼
              </div>
              <div class="b">
                <div class="n">运行时长：</div>12 h
              </div>
              <div class="e"><el-switch class="sw" v-model="value2" size="mini" active-color="#13ce66"
                  inactive-color="#CCC">
                </el-switch>
                <img class="swImg" v-if="value2" src="./img/lg.png">
                <img class="swImg" v-else src="./img/la.png">
                <div class="swUl" :class="{'active': value2}">
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                </div>
              </div>
            </div>
            <div slot="reference" class="name-wrapper" style="top: 15.5%;left: 72.4%;">
              <img v-if="value2" src="./img/l1.png">
              <img v-else src="./img/l3.png">
            </div>
          </el-popover>

          <el-popover trigger="click" placement="right-start">
            <div class="popo_box">
              <div class="a  " :class="{'active2': !value2}" :style="{backgroundColor:value2?'#368ed9':'#e6e6e6'}">
                1#照明回路
              </div>
              <div class="b">
                <div class="n">设备编号：</div>zm167
              </div>
              <div class="b">
                <div class="n">设备位置：</div>A栋A座1楼
              </div>
              <div class="b">
                <div class="n">运行时长：</div>12 h
              </div>
              <div class="e"><el-switch class="sw" v-model="value2" size="mini" active-color="#13ce66"
                  inactive-color="#CCC">
                </el-switch>
                <img class="swImg" v-if="value2" src="./img/lg.png">
                <img class="swImg" v-else src="./img/la.png">
                <div class="swUl" :class="{'active': value2}">
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                  <div class="swLi"></div>
                </div>
              </div>
            </div>
            <div slot="reference" class="name-wrapper" style="top: 51.5%;left: 68.3%;">
              <img v-if="value2" src="./img/l1.png">
              <img v-else src="./img/l3.png">
            </div>
          </el-popover>


        </span>
      </div>

    </div>
  </div>
</template>

<script type="text/javascript">
  import elIconBtn from '@/components/module/iconBtns.vue'
  export default {
    //inject: ['reload'],
    components: {
      elIconBtn
    },
    data () {
      return {
        value2: false,
        value1: true,
        heights: Math.round((document.getElementById('app').clientHeight)*0.55),
        defaultProps: {
          children: 'children',
          label: 'typeName'
        },
        filterText: "",
        filterText2: "",
        getEntityTypeList: this.$store.unitStore.state.getEntityTypeList,
        typeEnum: 0,

      }
    },
    created () {
      debugPage=this
    },

    methods: {
      goUrl (v) {
        // this.$router.push(v)
        this.$parent.goUrl(0);
      },
      checkItem (data) {

      },
      //筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.typeName.indexOf(value)!==-1;
      },


    }
  }
</script>

<style scoped lang="scss">
  .swUl {
    display: flex;
    border-radius: 5px;
    overflow: hidden;
    margin-right: 10px;

    .swLi {
      background: #ccc;
      width: 19px;
      height: 16px;
      margin-right: 1px;
    }

    .swLi:nth-child(n+4) {
      background: #e6e6e6;
    }
  }

  .active .swLi {
    background: #1890FF;
  }

  .swImg {
    width: 15px;
    height: 15px;
    margin-right: 4px;
    margin-left: 12px;
  }

  .popo_box {
    .e {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      margin-top: 3px;

      .sw {
        transform: scale(.6);
      }
    }

    .a {
      background: #368ED9;
      color: #FFFFFF;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 14px;
      padding: 5px 10px;
      margin-bottom: 9px;
    }

    .active2 {
      color: #666;
    }

    .b {
      display: flex;
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 12px;
      padding: 0px 10px;
      margin-top: 6px;

      .n {
        color: #666;
        font-family: Microsoft YaHei;
        font-weight: regular;
        font-size: 12px;

      }

    }
  }

  .titles {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 8px;
    color: #666666;
    font-family: Microsoft YaHei;
    font-weight: regular;
    font-size: 12px;

    .rightd {
      border-radius: 4px;
      background: #FFF;
      border: 1px solid #E6E6E6;
      display: flex;
      align-items: center;
      cursor: pointer;
      overflow: hidden;
    }

    .leftd {
      display: flex;
      align-items: center;

      img {
        margin-right: 20px;
      }
    }
  }

  .name-wrapper {
    position: absolute;
    width: 50px;
  }

  .spot img {
    position: absolute;
    width: .5rem;
    height: .5rem;
    left: 0;
    top: 0;
  }

  .center {
    position: relative;
  }

  .num_box {
    display: flex;
    border-radius: 4px;
    border: 1px solid #EBEBEB;
    justify-content: space-around;
    margin-top: 20px;
    height: 66px;
    align-items: center;

    .line {
      width: 1px;
      height: 42px;
      background-color: #EBEBEB;
    }

    .num {
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 2px;
      text-align: center;
    }

    .e {
      color: #666;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 12px;

    }
  }

  .custom-tree-node {
    display: flex;
    width: calc(100% - 51px);

    .tt {
      padding: 0px 5px;
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 14px;

    }

    .aaa {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 12px;
      align-items: center;
    }
  }

  .archiverstype {
    .con {
      width: 100%;
      min-height: 100%;
      box-sizing: border-box;
      display: flex;
      padding: 8px;

      .left-tree {
        width: 224px;
        min-height: 100%;
        background-color: #fff;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 12px;
        padding-top: 20px;

        .btns {
          margin-top: 20px;
          color: #1A1A1A;
          font-family: Microsoft YaHei;
          font-weight: regular;
          font-size: 14px;
          display: flex;
          justify-content: space-between;

          .txt {
            font-family: Microsoft YaHei;
            font-weight: regular;
            font-size: 12px;
            padding-right: 8px;
          }

          .i {
            color: #0D75D4;
            font-family: Microsoft YaHei;
            font-weight: regular;
            font-size: 12px;
          }
        }

        /deep/.el-button {
          padding: 6px 11px !important;
        }
      }

      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }


    }
  }

  .right-table {
    width: calc(100% - 232px);
    min-height: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 20px;


  }
</style>
<style>
  .el-scrollbar__wrap {
    overflow: auto;
  }

  .el-popover {
    padding: 0 !important;
    border-radius: 4px;
    overflow: hidden;
  }
</style>